import { Button } from '@mui/material';
import { getSelectorAttribute, perUnitUsageChargeEditBottomSectionSelectors } from '@weft/app-selectors';
import { VyIcon } from '@weft/icons';
import type { PerUnitProduct } from '@weft/services';
import type { UsageProductInput } from '@weft/types';
import { removeInIndex } from '@weft/utils';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { TrashIcon } from '../../../../../../../../components/icons/TrashIcon';
import { useDialog } from '../../../../../../../../hooks/use-dialog';
import type { PlanInputForm } from '../../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { UsageChargeEditDrawer } from '../../../../UsageChargeEditDrawer/UsageChargeEditDrawer';

type PerUnitUsageChargeEditBottomSectionProps = {
  productIndex: number;
  product: PerUnitProduct;
};

export const PerUnitUsageChargeEditBottomSection: React.FC<PerUnitUsageChargeEditBottomSectionProps> = ({ productIndex, product }) => {
  const { isDialogOpen: isDrawerOpen, handleOpen, handleClose } = useDialog();
  const { setValue, getValues } = useFormContext<PlanInputForm>();

  const onDelete = useCallback(() => {
    const updatedProducts = removeInIndex(getValues('usageProducts'), productIndex);
    setValue('usageProducts', updatedProducts);
  }, [productIndex]);

  return (
    <div className="border-t-line flex items-center justify-between">
      <Button
        className="min-w-fit"
        sx={{
          color: '#576063',
          background: isDrawerOpen ? '#E1E6E8' : '#F0F4F6',
          fontWeight: '500',
          fontSize: '14px',
          boxShadow: 'none',
          columnGap: '10px',
          borderRadius: '6px',
          padding: '6px 12px',
        }}
        onClick={handleOpen}
      >
        <VyIcon
          color="#576063"
          icon="Edit2"
        />
        <span>Modify</span>
      </Button>

      <UsageChargeEditDrawer
        open={isDrawerOpen}
        onClose={handleClose}
        usageProduct={product as UsageProductInput}
      />

      <div className="fill-icon space-x-5.5 flex justify-end">
        <TrashIcon
          onClick={() => onDelete()}
          {...getSelectorAttribute(perUnitUsageChargeEditBottomSectionSelectors.trashButton)}
        />
      </div>
    </div>
  );
};